/**
 * Customer Support Contact Information Constants
 */

export const SUPPORT_PHONE_NUMBERS = {
  INDIA: {
    display: '+91 80 4711 0244',
    tel: '+918047110244',
    whatsapp: 'https://wa.me/918047110244',
    fallback: '8047110244', // Without +91 prefix
    hours: {
      anytime: 'Our support team is available to help you at any time.',
    },
  },
  // US: {
  //   display: '+1 213 556 4363',
  //   tel: '+12135564363',
  //   hours: {
  //     weekdays: 'Mon–Fri: 10AM–9PM EST',
  //     weekends: 'Sat–Sun: 10AM–7PM EST',
  //   },
  // },
} as const;

/**
 * Renewal hand-off to a person. This WhatsApp number is the CSOC bot's channel;
 * a message carrying an Enquiry ID created with source 'renewal' skips the bot
 * and goes straight to the renewals agent (chatbot: is_renewal_page_enquiry).
 * Without the Enquiry ID the bot answers instead.
 */
export const RENEWAL_AGENT_WHATSAPP = {
  number: '918047358900',
  display: '+91 80473 58900',
  message: 'Hi, I need help renewing my plan.',
} as const;

export const renewalAgentWhatsAppUrl = (leadRef?: string | null) => {
  const text = leadRef
    ? `${RENEWAL_AGENT_WHATSAPP.message} Enquiry ID: ${leadRef}`
    : RENEWAL_AGENT_WHATSAPP.message;
  return `https://wa.me/${RENEWAL_AGENT_WHATSAPP.number}?text=${encodeURIComponent(text)}`;
};

export const SUPPORT_REQUIRED_TOURNAMENT_IDS: number[] = [
  46791, // Master Pride
  46802, // Master Pride Plus
  // 29551, // Duel Batch (IND)
  // 35356, // Duel Batch (USA)
];

